var $2fa80cee796b989c$exports = {};
$2fa80cee796b989c$exports = {
  "alert": "\u0421\u0438\u0433\u043D\u0430\u043B \u0442\u0440\u0438\u0432\u043E\u0433\u0438",
  "dismiss": "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
};
export { $2fa80cee796b989c$exports as default };